import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '@shared/services';

@Component({
    selector: 'app-logout',
    template: ``
})
export class LogoutComponent {

  constructor(
    private _storage: StorageService,
    private _route: Router,
  ) { 
    this._storage.cleanUpStorage();
    this._route.navigateByUrl('/login');
  }

}
